// Packages:
import { useState, useEffect, useRef } from "react"
import courseModules from '../data/courseModules.json'
import { useParams } from "react-router-dom"

//Components:
import Header from "../components/details/header" 
import CourseModule from "../components/details/courseModule"
import Courses from "../components/details/courses"
import Advantages from "../components/details/advantages"
import Contact from "../components/home/contact"
import NotFound from "./notFound"

// Typescript
export interface courseDataType {
    id: number
    title: string
    icon: string
    shortDesc: string
    longDesc: string
    duration: number
    experienceRequired: string
    experienceSubText: string
    studyMode: string
    studySubText: string
    course: {
        title: string
        time: string
        points: {title: string}[]
    }[]
}

export interface RecommendedCoursesType {
    id: number
    icon: string
    title: string
    shortDesc: string
}
const Details = () => {
    // Constants:
    const contactRef = useRef<HTMLDivElement>(null)
    const params = useParams()
    const scrollToContact = () => {
        contactRef?.current?.scrollIntoView({
            behavior: 'smooth', // Defines the scroll behavior
          })
    }
    // States:
    const [courseData, setCourseData] = useState<courseDataType>()
    const [recommendedCourses, setRecommendedCourses] = useState<any>()

    // Effects:
    useEffect(()=>{
        window.scrollTo(0, 0)
    },[])

    useEffect(()=>{
        setCourseData(courseModules.filter(item=> item.id === Number(params?.courseId))[0])
        
        const arr = courseModules.map(item=> (item.id !== Number(params?.courseId) ? 
        {
            id: item.id,
            icon: item.icon,
            title: item.title,
            shortDesc: item.shortDesc
        } : undefined
        ))

        setRecommendedCourses(arr.filter(item => item !== undefined))
    },[params?.courseId])
    
    useEffect(()=>{
        console.log(contactRef)
    },[])

    useEffect(()=>{
        if (Number(params?.courseId) > courseModules?.length - 1)
            throw new Error('404 Course not found')
        
    },[])

    // Return 
    return <>
        <Header courseData={courseData} scrollToContact={scrollToContact}/>
        <CourseModule courseData={courseData}/>
        <Courses recommendedCourses = {recommendedCourses}/>
        <Advantages />
        <Contact contactRef={contactRef} />
        </>
}

export default Details